import React from 'react';
import { Form, Select } from 'antd';
import { useGetAllStatuses } from 'shared/hooks/use-get-all-statuses.ts';

interface ICargoFiltersStatusInputProps {
  name: string;
  disabled?: boolean;
  className?: string;
  handleSuccess: () => void;
}

export const CargoFiltersStatusInput: React.FC<ICargoFiltersStatusInputProps> = (props) => {
  const { name, disabled = false, className, handleSuccess } = props;

  const statuses = useGetAllStatuses();

  return (
    <Form.Item name={name} className={className}>
      <Select placeholder='Status' mode='multiple' disabled={disabled} allowClear onChange={handleSuccess}>
        {statuses.statusesList.map((status) => (
          <Select.Option key={status} value={status}>
            {status}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
